import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import {
  SubmitButton,
  FormikInputField,
  FieldWrapper,
} from 'base/components/forms';
import Button from 'base/components/Button';
import Steps, { Step } from 'base/Steps';
import { closeModal } from 'modal/store/actions';
import theme, { textBold } from 'theme/theme';
import {
  get2FaQrCodeUrl,
  getEnable2FaHasError,
  get2FaSecret,
} from '../../store/auth/selectors';
import {
  init2Fa,
  enable2Fa,
} from '../../store/auth/actions';

const ErrorMessage = styled.div`
  margin: 0 0 2rem 0;
  ${textBold};
  color: ${theme.colors.primary};
`;

const androidUrl = 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2';
const iOsUrl = 'http://appstore.com/googleauthenticator';

class Setup2Fa extends React.Component {
  state = {
    currentStep: 0,
  };

  componentDidMount() {
  }

  nextStep = () => this.setState((prevState) => ({ currentStep: prevState.currentStep + 1 }));

  handleStep0 = () => {
    const { init2Fa } = this.props;
    init2Fa();
    this.nextStep();
  };

  render() {
    const {
      enable2FaHasError, user, qrCodeUrl, secret, enable2Fa, onSubmit, // eslint-disable-line
    } = this.props;
    const {
      currentStep,
    } = this.state;

    const step0 = (
      <>
        <FieldWrapper>
            Download Authenticator for
          {' '}
          <a href={iOsUrl} target="_blank" rel="noopener noreferrer">iOS</a>
            &nbsp;or
          {' '}
          <a href={androidUrl} target="_blank" rel="noopener noreferrer">Android</a>
.
        </FieldWrapper>
        <Button variant="secondary" onClick={this.handleStep0}>
            Next
        </Button>
      </>
    );

    const step1 = (
      <>
        <FieldWrapper>
            Use the Authenticator app to scan this QR code:
        </FieldWrapper>
        {qrCodeUrl && (
          <FieldWrapper>
            <img src={qrCodeUrl} alt="Authenticator QR code" />
          </FieldWrapper>
        )}
        <Button variant="secondary" onClick={this.nextStep}>
            Next
        </Button>
      </>
    );

    const form = ({ errors, isSubmitting, values }) => ( // eslint-disable-line
      <Form>
        <FieldWrapper>
          <strong>
              Set up 2-factor authentication in 3 simple steps:
          </strong>
        </FieldWrapper>


        <Steps current={currentStep} style={{ marginBottom: '1rem' }}>
          <Step title="Download App" />
          <Step title="Scan QR code" />
          <Step title="Activate" />
        </Steps>

        {currentStep === 0 && step0}
        {currentStep === 1 && step1}
        {currentStep === 2 && (
          <>
            {enable2FaHasError && (
            <ErrorMessage style={{
              color: '#fff',
              background: theme.colors.primary,
              padding: '10px',
              margin: '10px 0',
            }}
            >
                      Invalid verification code. Please try again.
            </ErrorMessage>
            )}

            <Field
              type="text"
              name="otp"
              label="Enter the verification code generated by your app to finish the setup."
              placeholder="Verification code"
              component={FormikInputField}
            />

            <FieldWrapper>
                  Note: for security reasons, you will have to login again
                  after enabling 2-factor authentication
            </FieldWrapper>

            <SubmitButton type="submit" disabled={false}>
                  Activate 2-factor authentication
            </SubmitButton>
          </>
        )}
      </Form>
    );

    return (
      <Formik
        initialValues={{
          otp: '',
        }}
        validationSchema={
              Yup.object().shape({
                otp: Yup.string()
                  .required('Verification code is required.'),
              })
            }
        render={form}
        onSubmit={(values) => {
          onSubmit(values);
          enable2Fa(values.otp, secret);
        }}
      />
    );
  }
}
Setup2Fa.propTypes = {
  init2Fa: PropTypes.func.isRequired,
  enable2Fa: PropTypes.func.isRequired,
  enable2FaHasError: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func,
};
Setup2Fa.defaultProps = {
  onSubmit: () => {},
};

const mapStateToProps = (state) => ({
  qrCodeUrl: get2FaQrCodeUrl(state),
  secret: get2FaSecret(state),
  enable2FaHasError: getEnable2FaHasError(state),
});

const mapDispatchToProps = {
  closeModal,
  init2Fa,
  enable2Fa,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Setup2Fa);
